export default "__VITE_ASSET__h7pFOqy4__"